<!-- ▼ ▼ ▼ 差分強調表示用テンプレート(通常) ▼ ▼ ▼ -->
<ng-template #emph let-content>
  <em
    [ngClass]="{
      del: content?.type === 'del',
      'c-modified-element': content?.type === 'del' || content?.type === 'diff',
      'c-modified-element--has-icon': content?.type === 'del' || content?.type === 'diff'
    }"
  >
    <span *ngIf="content?.value" [innerHTML]="content?.value"></span>
    <span *ngIf="!content?.value" [innerHTML]="'label.hyphen' | staticMsg"></span>
    <span *ngIf="content?.type === 'del' || content?.type === 'diff'" class="c-modified-element__icon">
      <img
        class="c-modified-element__icon-img"
        src="{{ appConstants.IMG.R01_P040_S01_U__ICON_CHANGE_10 }}"
        width="10"
        height="10"
        alt="変更箇所"
      />
    </span>
    <span
      *ngIf="content?.type === 'del' || content?.type === 'diff'"
      class="u-visually-hidden"
      [innerHTML]="'reader.diffIcon' | staticMsg"
    ></span>
    <span
      *ngIf="content?.type === 'del'"
      class="u-visually-hidden"
      [innerHTML]="'reader.revokedService' | staticMsg"
    ></span>
  </em>
</ng-template>

<!-- ▼ ▼ ▼ 差分強調表示用テンプレート(代表者メールアドレス) ▼ ▼ ▼ -->
<!-- ※未登録時の文言が他項目と異なる -->
<ng-template #emphRepEmail let-content>
  <em
    [ngClass]="{
      del: content?.type === 'del',
      'c-modified-element': content?.type === 'del' || content?.type === 'diff',
      'c-modified-element--has-icon': content?.type === 'del' || content?.type === 'diff'
    }"
  >
    <span *ngIf="content?.value">{{ content?.value }}</span>
    <span *ngIf="!content?.value" [innerHTML]="'label.requestForRegistration' | staticMsg"></span>
    <span *ngIf="content?.type === 'del' || content?.type === 'diff'" class="c-modified-element__icon">
      <img
        class="c-modified-element__icon-img"
        src="{{ appConstants.IMG.R01_P040_S01_U__ICON_CHANGE_10 }}"
        width="10"
        height="10"
        alt="変更箇所"
      />
    </span>
    <span
      *ngIf="content?.type === 'del' || content?.type === 'diff'"
      class="u-visually-hidden"
      [innerHTML]="'reader.diffIcon' | staticMsg"
    ></span>
    <span
      *ngIf="content?.type === 'del'"
      class="u-visually-hidden"
      [innerHTML]="'reader.revokedService' | staticMsg"
    ></span>
  </em>
</ng-template>

<!-- 以下、本体 -->
<div class="p-manage-booking">
  <div class="p-manage-booking__item" [ngClass]="{ 'grey-bg': !isPlanValid }">
    <!-- 見出し部分 -->
    <div class="p-manage-booking__item-head p-manage-booking__item-head--has-btn">
      <div class="p-manage-booking__item-title">
        <div
          class="p-manage-booking__item-title-label p-manage-booking__item-title-label-em"
          [innerHTML]="'label.representativeSelectionGroup' | staticMsg"
        ></div>
      </div>
      <div>
        <!-- 代表者連絡先情報編集ボタン -->
        <asw-button
          id="plan-review-representative-contacts-open-passenger-info-req-modal-btn"
          size="xs"
          (click$)="openPassengerInfoRequest(-1)"
          [throttleClick]="true"
          [disabled]="!isPlanValid"
          [label]="'label.edit' | staticMsg"
        ></asw-button>
      </div>
    </div>

    <dl class="c-float-list01 c-def-list02">
      <div class="c-float-list01__item">
        <!-- 代表者メールアドレス -->
        <dt class="c-float-list01__title" [innerHTML]="'label.eMailAddress.passengerInput' | staticMsg"></dt>
        <dd class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal">
          <ng-container *ngTemplateOutlet="emphRepEmail; context: { $implicit: data.email }"></ng-container>
        </dd>
      </div>
      <div class="c-float-list01__item">
        <!-- 代表者電話番号 -->
        <dt class="c-float-list01__title" [innerHTML]="'label.telNumber.passengerInput' | staticMsg"></dt>
        <dd class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal">
          <ng-container *ngTemplateOutlet="emph; context: { $implicit: data.phone }"></ng-container>
        </dd>
      </div>
    </dl>
  </div>
</div>
